import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

import Header from '@components/Details/Header'
import Scroll from '@components/Scroll'
import Pagination from '@components/Pagination'

import ExpertPaymentsTable from './ExpertPaymentsTable'
import ExpertPaymentsActions from './ExpertPaymentsActions'

function ExpertPaymentsList ({ expertPaymentsStore }) {
  const { loading, count, query, changePage } = expertPaymentsStore

  return (
    <div className='expert-payments-list'>
      <Scroll>
        <div className='project-wrapper'>
          <Header>
            <h1>Expert Payments</h1>
          </Header>
          <ExpertPaymentsActions expertPaymentsStore={expertPaymentsStore} />
          <ExpertPaymentsTable expertPaymentsStore={expertPaymentsStore} />
          {!loading && (
            <Pagination
              total={count}
              perPage={query.limit}
              page={query.page}
              onChange={changePage}
            />
          )}
        </div>
      </Scroll>
    </div>
  )
}

ExpertPaymentsList.propTypes = {
  expertPaymentsStore: PropTypes.object.isRequired
}

export default observer(ExpertPaymentsList)
